import { TOUR_BASE_QUERY_KEY } from '@/features/dashboard/tours/api/toursApi.queryKeys.ts';

export const TOUR_BUDGET_KEY_SEGMENT = 'budget';

export const tourBudgetApiQueryKeys = {
  byTourId: (tourId: string) =>
    [TOUR_BASE_QUERY_KEY, tourId, TOUR_BUDGET_KEY_SEGMENT] as const,
};
